export default __webpack_public_path__ + "static/media/fun.bbd63bf2.png";